var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFoundIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5534 69.6129C57.9262 67.9858 57.9262 65.3476 59.5534 63.7204C61.1806 62.0932 63.8188 62.0932 65.446 63.7204L82.1126 80.3871C83.7398 82.0142 83.7398 84.6524 82.1126 86.2796C80.4854 87.9068 77.8472 87.9068 76.2201 86.2796L59.5534 69.6129Z",
    fill: "#ECECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8332 66.6667C57.3391 66.6667 66.6665 57.3393 66.6665 45.8334C66.6665 34.3275 57.3391 25.0001 45.8332 25.0001C34.3272 25.0001 24.9998 34.3275 24.9998 45.8334C24.9998 57.3393 34.3272 66.6667 45.8332 66.6667ZM45.8332 75.0001C29.7249 75.0001 16.6665 61.9417 16.6665 45.8334C16.6665 29.7251 29.7249 16.6667 45.8332 16.6667C61.9415 16.6667 74.9998 29.7251 74.9998 45.8334C74.9998 61.9417 61.9415 75.0001 45.8332 75.0001Z",
    fill: "#ECECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundIcon);
export default __webpack_public_path__ + "static/media/not-found-icon.a38516a9e89439b73d00e2bdbe1ec323.svg";
export { ForwardRef as ReactComponent };